import i18n from '../../i18n';

export class Text {
  static get errorText(): string {
    return i18n._translate('Whoops! An error occurred.', {
      context: 'A message telling the user that something is not working correctly.',
    });
  }
}
